@if (viewVisible) {
  <lfw-form-edit-toolbar>
    <ng-container toolbar-left>
      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.SAVE' | translate }}"
        icon="save"
        (click)="save()"
        [disabled]="!canSave() || isClosing()" />
      <lfw-toolbar-divider class="desktop-only" toolbar-left></lfw-toolbar-divider>
      <lfw-toolbar-button
        class="desktop-only"
        [disabled]="!canFinalize() || isClosing()"
        [tooltip]="tooltipForFinalizeButton()"
        label="{{ 'ORDERS.FINISH' | translate }}"
        icon="check_circle"
        (click)="finalize()" />
    </ng-container>

    <ng-container toolbar-center>
      <lfw-toolbar-text text="{{ caption }}" />
    </ng-container>

    <ng-container toolbar-right>
      @if (form) {
        <lfw-sub-state-select
          [availableStates]="form!.subStates"
          (changed)="subStateSelectionChanged()"
          [(order)]="form!.order"></lfw-sub-state-select>
      }

      <lfw-order-editor-mobile-menu
        [canSave]="canSave()"
        [canFinalize]="canFinalize()"
        [canClose]="!isClosing()"
        [tooltipForFinalizeButton]="tooltipForFinalizeButton()"
        (save)="save()"
        (finalize)="finalize()"
        (closeForm)="close()" />

      <lfw-toolbar-button
        class="desktop-only"
        label="{{ 'DIALOGS.CLOSE' | translate }}"
        icon="close"
        [disabled]="isClosing()"
        (click)="close()" />
    </ng-container>
  </lfw-form-edit-toolbar>

  @if (form) {
    <lfe-liveforms-editor
      #editor
      [form]="form"
      [userInfo]="user"
      [settings]="editorSettings"
      (formChanged)="formChanged()" />
  }
}
